// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__nwDOO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1etsW"};